import shared from 'emun.prospect/prospect.config';

export default Object.assign({}, shared, {
  hideVendor: false,
  showRanking: true,
  showQualification: true,
    filters: [
        { groupBy: 'Status', title: 'Status' },
        { groupBy: 'salesRepID', title: 'Sales Rep' }
    ]
});
